import { createOnlineDemoLanding } from "./landing/onlineDemoLanding";

const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
const params = new URLSearchParams(window.location.search);
const isDevModelViewer = import.meta.env.DEV && params.get("modelViewer") === "1";

if (pathname === "/" && !isDevModelViewer) {
  const overlay = document.getElementById("overlay");
  if (overlay) overlay.style.display = "none";
  createOnlineDemoLanding();
} else if (pathname === "/" && isDevModelViewer) {
  void import("./main").catch((error: unknown) => {
    console.error(error);
    const overlay = document.getElementById("overlay");
    if (!overlay) return;
    const detail = error instanceof Error ? error.message : String(error);
    overlay.textContent = (navigator.language || "").toLowerCase().startsWith("es")
      ? `No se pudo iniciar el juego: ${detail}`
      : `Could not start the game: ${detail}`;
    overlay.style.display = "block";
  });
} else {
  const destination = new URL("/", window.location.origin);
  const language = params.get("lang");
  if (language === "es" || language === "en") destination.searchParams.set("lang", language);
  window.location.replace(destination.href);
}
